import { render, staticRenderFns } from "./CompWrong.vue?vue&type=template&id=156ff3ba&"
import script from "./CompWrong.vue?vue&type=script&lang=ts&"
export * from "./CompWrong.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports